module.exports = __webpack_public_path__ + "static/img/banner-KeP.1505eb2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner-KeP.png
// module id = 387
// module chunks = 1